module.exports = __webpack_public_path__ + "img/wro-2023-senior.ba89a4b8.png";